// extracted by mini-css-extract-plugin
export default {"container":"Cq-z","brandName":"Dq-z","productName":"Eq-z","productNamePdpEnhancements":"Fq-z","breakLongProductName":"Gq-z"};